import uniqid from 'uniqid';
import * as R from 'ramda';
import { all, select, fork, cancel, race, call, put, take, takeEvery, takeLatest, cancelled } from 'redux-saga/effects';
import { receiveConnections, fetchLastConnection } from '../reducers/connectionReducer';
import entityActions from '../genericActions/entityActions';
import tabOrchestrator from './tabs/tabSaga';
import dbConnectionsSagas from './db/dbConnectionsSagas';
import { vbqlResultsWatcher } from '../../models/vbqlResults/vbqlResultsEffects';

const LAST_CONNECTION_KEY = 'lastConnectionId';

const fetchLastConnectionProcess = function* (action) {
  let response;
  try {
    const lastConnectionId = localStorage.getItem(LAST_CONNECTION_KEY);
    response = yield select(store => store.connection.byId[lastConnectionId]);
  } catch (err) {
    console.error(err);
  }

  if (response) {
    yield put(receiveConnections(
      action.payload.keyWindow,
      [response],
    ));
  } else {
    yield put(entityActions.receiveErrors(
      action.payload.keyWindow,
      { connection: [] },
    ));
  }
};

/*
const deleteConnectionProcess = function* (action) {
  yield localStorage.setItem(`${LOCAL_STORAGE_NAMESPACE}__connections`, JSON.stringify(action.payload.data));

  yield put(removeConnections(
    action.payload.keyWindow,
    action.payload.data,
  ));
};
*/

const selectConnectionProcess = function* (action) {
  const connection = yield select(store => store.connection.byId[action.payload.id]);
  yield localStorage.setItem(LAST_CONNECTION_KEY, action.payload.id);

  yield put(receiveConnections(
    action.payload.keyWindow,
    [connection],
  ));
};

const connectionsSaga = function* () {
  yield call(
    dbConnectionsSagas.getAllSaga,
    '/connections',
  );

  yield call(
    fetchLastConnectionProcess,
    yield put(fetchLastConnection('/window')),
  );

  yield all([
    yield takeLatest(
      action => action.type === 'SAVE_CONNECTION',
      dbConnectionsSagas.updateSaga,
    ),
    yield takeLatest(
      action => action.type === 'CREATE_CONNECTION',
      dbConnectionsSagas.addSaga,
    ),
    yield takeLatest(
      action => action.type === 'DELETE_CONNECTION',
      dbConnectionsSagas.deleteSaga,
    ),
    yield takeLatest(
      action => action.type === 'SELECT_CONNECTION',
      selectConnectionProcess,
    ),
  ]);
};

const connectionOrchestrator = function* connectionSaga() {
  const connection = yield select(store => store.connection.byId[store.connection['/window'].ids[0]]);

  yield fork(vbqlResultsWatcher);
  yield fork(tabOrchestrator, connection.id);
};

const main = function* main() {
  yield fork(connectionsSaga);

  yield takeLatest(
    action => (
      action.type === 'RECEIVE_ENTITIES' &&
      action.payload.keyWindow === '/window' &&
      action.payload.entities.connections
    ),
    connectionOrchestrator,
  );

  /*
  //takeLatest('CONNECT', connectionSaga, id);
  // yield fork(connectionsSaga);
  */
};

export default main;
